import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Input,
  ModalBody,
  Label,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { MDBDataTable } from "mdbreact";
import { Link, useParams } from "react-router-dom";
import { connect } from "react-redux";
import * as url from "../../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { setBreadcrumbItems } from "../../../store/actions";
import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
const DesignationList = (props) => {
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Category List", link: "#" },
  ];
  useEffect(() => {
    if (cateId) {
      onGetDesignationList(cateId);
    }
    onGetCategoryList();
  }, []);
  useEffect(() => {
    props.setBreadcrumbItems("List", breadcrumbItems);
  });

  const [SelectedCategory, setSelectCategory] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [category, setCategory] = useState({});
  const [designationDetail, setDesignationDetail] = useState({});
  const [categoryName, setCategoryName] = useState("");
  const [designationName, setDesignationName] = useState("");
  const [status, setStatus] = useState("");
  const [addModal, setAddModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [type, setTypeModel] = useState("");
  const [editId, setEditId] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { cateId } = useParams();
  const statusOptions = [
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
  ];
  const handleDelete = async (e) => {
    e.preventDefault();
    setShowDeleteModal(false);
    setLoading(true);
    try {
      const response = await fetch(
        url.AUTH_URL + `delete-designation/${selectedId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      if (result.status) {
        toast.success("Designation Deleted Successfully!");
        setDesignationList((prev) =>
          prev.filter((item) => item._id !== selectedId)
        );
        setLoading(false);
        setShowDeleteModal(false);
      } else {
        toast.error("Update failed.");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.warn("Something went wrong!");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (type === "add") {
      setAddModal(true);
      let urlPath = "create-designation";
      if (!category || !designationName) {
        toast.error("Please fill in all fields.");
        return;
      }
      const payload = {
        categoryid: category.value,
        name: designationName,
        status: status.value,
      };

      const response = await fetch(url.AUTH_URL + urlPath, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (result.status) {
        setCategoryName("");
        setStatus("");
        setDesignationName("");
        setDesignationList((prev) => [...prev, result.designation.data]);
        toast.success(result.message);
        setAddModal(false);
      }
    } else if (type === "edit") {
      let urlPath = `update-designation/${editId}`;
      const payload = {
        categoryid: designationDetail.catId,
        name: designationName,
        status: designationDetail.status,
      };
      const response = await fetch(url.AUTH_URL + urlPath, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (result.status) {
        setDesignationList((prev) =>
          prev.map((item) =>
            item._id === editId ? result.designation.data : item
          )
        );
        toast.success(result.message);
        setEditModal(false);
      }
    }

    setViewModal(false);
  };
  function onGetCategoryList() {
    let urlPath = "getCategory";
    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          var data = responseData.data;

          const cate = [
            {
              options: [
                { label: "--Select--", value: "" },
                ...data.map((c) => ({ label: c.name, value: c._id })),
              ],
            },
          ];
          setCategoryOptions(cate);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  function onGetDesignationList(id) {
    setLoading(true);
    let categoryId;
    if (cateId) {
      categoryId = cateId;
    } else {
      categoryId = id;
    }
    let urlPath = "getDesignation/" + categoryId;
    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json()) // parse JSON here
      .then((responseData) => {
        if (responseData.status) {
          setDesignationList(responseData.data);
        }
      })
      .catch((error) => {
        console.log(error);
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  function getDesignationDetails(id) {
    setEditId(id);
    let urlPath = `getDesignationDetails/${id}`;

    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          const data = responseData.data;
          setDesignationName(data.name);
          setDesignationDetail({
            name: data.name,
            status: data.status,
            categoryName: data.categoryid.name,
            catId: data.categoryid._id,
          });
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        toast.error("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }
  const formattedEventList = designationList.map((designation) => ({
    ...designation,
    Action: [
      <Link
        to="#"
        onClick={(e) => {
          e.preventDefault();
          setViewModal(true);
          getDesignationDetails(designation._id);
        }}
        className="btn btn-info btn-sm  "
      >
        {" "}
        <span className="menu-text" style={{ color: "white" }}>
          {" "}
          <span className=" menu-icon fas fa fa-eye" style={{ color: "white" }}>
            {" "}
          </span>
        </span>{" "}
      </Link>,
      <Link
        onClick={(e) => {
          e.preventDefault();
          setEditModal(true);
          setTypeModel("edit");
          getDesignationDetails(designation._id);
        }}
        className="btn btn-warning btn-sm  m-1"
      >
        {" "}
        <span className="menu-text" style={{ color: "white" }}>
          {" "}
          <span className="menu-icon fas fa fa-edit" style={{ color: "white" }}>
            {" "}
          </span>
        </span>{" "}
      </Link>,
      <Link
        className="btn btn-danger btn-sm  m-1"
        onClick={(e) => {
          e.preventDefault();
          setSelectedId(designation._id);
          setShowDeleteModal(true);
        }}
      >
        {" "}
        <span className="menu-text" style={{ color: "white" }}>
          {" "}
          <span
            className="menu-icon fas fa fa-trash"
            style={{ color: "white" }}
          >
            {" "}
          </span>
        </span>{" "}
      </Link>,
    ],
  }));
  const tableData = {
    columns: [
      {
        label: "Designation Name",
        field: "name",
        sort: "asc",
        width: 23,
      },
      {
        label: "Status",
        field: "status",
        sort: "asc",
        width: 10,
      },
      {
        label: "Action",
        field: "Action",
        sort: "asc",
        width: 20,
      },
    ],
    rows: formattedEventList,
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="9">
                    <CardTitle className="h4 mb-0">
                      Manage Designation
                    </CardTitle>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="row">
                  <Modal
                    size="m"
                    centered
                    show={viewModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => setViewModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>View Designation</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                      <div className="row">
                        <table className="table table-bordered table-striped dataTable">
                          <tbody>
                            <tr>
                              <th>Category Name</th>
                              <td>{designationDetail.categoryName}</td>
                            </tr>
                            <tr>
                              <th>Designation Name</th>
                              <td>{designationDetail.name}</td>
                            </tr>
                            <tr>
                              <th>Status</th>
                              <td>
                                <i className="badge bg-success text-white p-2">
                                  {designationDetail.status}
                                </i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={(e) => setViewModal(false)}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
                <div className="row">
                  <Modal
                    size="m"
                    centered
                    show={addModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => setAddModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Add Designation</Modal.Title>
                    </Modal.Header>
                    <form onSubmit={handleSubmit}>
                      <Modal.Body>
                        <div className="mb-3">
                          <div className="form-group">
                            <Label className="form-label">Category Name</Label>
                            <Select
                              classNamePrefix="select2-selection"
                              value={category}
                              options={categoryOptions}
                              onChange={(e) => {
                                setCategory(e);
                              }}
                            ></Select>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="form-group">
                            <label className="form-label">
                              Designation Name
                            </label>
                            <Input
                              className="form-control"
                              value={designationName}
                              onChange={(e) => {
                                setDesignationName(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="form-group">
                            <label className="form-label">Status</label>
                            <Select
                              classNamePrefix="select2-selection"
                              options={statusOptions}
                              value={status}
                              onChange={(e) => {
                                setStatus(e);
                              }}
                            ></Select>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={(e) => setAddModal(false)}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          type="submit"
                          onClick={(e) => setTypeModel("add")}
                        >
                          Save
                        </Button>
                      </Modal.Footer>
                    </form>
                  </Modal>
                </div>
                <div className="row">
                  <Modal
                    size="m"
                    centered
                    show={editModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => setEditModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>
                        {editId === "Add" ? "Edit" : "Update"} Designation
                      </Modal.Title>
                    </Modal.Header>
                    <form onSubmit={handleSubmit}>
                      <Modal.Body>
                        <div className="mb-3">
                          <div className="form-group">
                            <Label className="form-label">Category Name</Label>
                            <Select
                              classNamePrefix="select2-selection"
                              value={categoryOptions
                                .flatMap((group) => group.options)
                                .find(
                                  (opt) => opt.value === designationDetail.catId
                                )}
                              options={categoryOptions}
                              onChange={(e) => {
                                setDesignationDetail((prev) => ({
                                  ...prev,
                                  catId: e.value,
                                }));
                              }}
                            ></Select>
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="form-group">
                            <label className="form-label">
                              Designation Name
                            </label>
                            <Input
                              className="form-control"
                              value={designationName}
                              onChange={(e) => {
                                setDesignationName(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <div className="form-group">
                            <label className="form-label">Status</label>
                            <Select
                              classNamePrefix="select2-selection"
                              options={statusOptions}
                              value={statusOptions.find(
                                (opt) => opt.value === designationDetail.status
                              )}
                              onChange={(e) => {
                                setDesignationDetail((prev) => ({
                                  ...prev,
                                  status: e.value,
                                }));
                              }}
                            ></Select>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={(e) => setEditModal(false)}
                        >
                          Close
                        </Button>
                        <Button variant="primary" onClick={handleSubmit}>
                          {editId === "add" ? "Add" : "Update"}
                        </Button>
                      </Modal.Footer>
                    </form>
                  </Modal>
                </div>
                <div className="row">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Select Category</label>
                        <Select
                          classNamePrefix="select2-selection"
                          value={SelectedCategory}
                          options={categoryOptions}
                          onChange={(e) => {
                            setSelectCategory(e);
                            onGetDesignationList(e.value);
                          }}
                        ></Select>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary"
                      onClick={() => setAddModal(true)}
                    >
                      <span className="fa fa-plus me-2"></span>Add Designation
                    </button>
                  </div>
                  <MDBDataTable responsive striped bordered data={tableData} />
                </div>
                <div className="row">
                  <Modal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to delete this item?
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowDeleteModal(false)}
                      >
                        Cancel
                      </Button>
                      <Button variant="danger" onClick={handleDelete}>
                        Yes, Delete
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(DesignationList);
